// extracted by mini-css-extract-plugin
export var active = "_av-7";
export var blink = "_av-8";
export var dropDownSelector = "_av-4";
export var dropDownWrapper = "_av-3";
export var fakeCursor = "_av-6";
export var fontSizeButton = "_av-9";
export var formQuillEditor = "_av-0";
export var pressed = "_av-a";
export var qlBlank = "_av-1";
export var textFormattingToolbar = "_av-2";
export var textToolbarOption = "_av-5";